document.addEventListener("DOMContentLoaded", function () {
  const lineObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("active");
        }
      });
    },
    {
      threshold: 0.2,
      rootMargin: "0px 10000px 0px 10000px",
    }
  );

  document.querySelectorAll(".animation-container--timeline").forEach((line) => {
    lineObserver.observe(line);
  });
});
